"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatInput = void 0;
const react_1 = __importStar(require("react"));
const ChatInput = ({ value, onChange, onSend, placeholder = 'Type a message...', disabled = false, sending = false, sendLabel = 'Send', sendingLabel = '...', multiline = false, }) => {
    const inputRef = (0, react_1.useRef)(null);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (value.trim() && !disabled && !sending) {
                onSend();
            }
        }
    };
    return (react_1.default.createElement("div", { className: "cw-chat-input-container" },
        multiline ? (react_1.default.createElement("textarea", { ref: inputRef, className: "cw-chat-input", value: value, onChange: (e) => onChange(e.target.value), onKeyDown: handleKeyDown, placeholder: placeholder, disabled: disabled || sending, rows: 2 })) : (react_1.default.createElement("input", { ref: inputRef, type: "text", className: "cw-chat-input", value: value, onChange: (e) => onChange(e.target.value), onKeyDown: handleKeyDown, placeholder: placeholder, disabled: disabled || sending })),
        react_1.default.createElement("button", { className: "cw-chat-send", onClick: onSend, disabled: !value.trim() || disabled || sending }, sending ? sendingLabel : sendLabel)));
};
exports.ChatInput = ChatInput;
